import React from "react";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import Button from "./Button/Button";

const DeleteConfirmModal = ({ isOpen, toggle, onConfirm, message = "Are you sure to delete it?", isLoading = false }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{message}</ModalHeader>
      <ModalFooter>
        <Button color="primary" variant="danger" onClick={onConfirm} isLoading={isLoading} disabled={isLoading} loadingText="Deleting...">Delete</Button>{" "}
        <Button color="secondary" variant="secondary" onClick={toggle} disabled={isLoading}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;
